import { ApiService } from "Services/ApiService";
import {
  OverallPromotionDTO,
  OverallPromotionResponseDTO,
  OverallPromotionResultDTO,
  ResultsDTO
} from "Types";


export const overallPromotionApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllOverallPromotions: builder.query<OverallPromotionResponseDTO[], void>({
      query: () => ({
        url: "admin/ecommerce-discount/",
        method: "GET",
        headers: {
          origin: "origin",
        },
      }),
      transformResponse: (res: ResultsDTO<OverallPromotionResponseDTO[]>) =>
        res.results ?? [],
      providesTags: [{ type: "EcommerceDiscount", id: "LIST" }],
    }),

    getOverallPromotionById: builder.query<OverallPromotionResultDTO<OverallPromotionResponseDTO>, number>({
      query: (id) => ({
        url: `admin/ecommerce-discount/${id}`,
        method: "GET",
        headers: {
          origin: "origin",
        },
      }),
      providesTags: (result, error, id) => [{ type: "EcommerceDiscount", id }],
    }),

    getDiscountsByPriceSlab: builder.query<ResultsDTO, number>({
      query: (price) => ({
        url: `admin/ecommerce-discount/getDiscountsByPriceSlab`,
        method: "GET",
        params: { price },
        headers: {
          origin: "origin",
        },
      }),
    }),

    createOverallPromotion: builder.mutation<ResultsDTO<OverallPromotionResponseDTO>, OverallPromotionDTO>({
      query: (data) => ({
        url: "admin/ecommerce-discount/create",
        method: "POST",
        body: data,
        headers: {
          origin: "origin",
        },
      }),
      invalidatesTags: () => [{ type: "EcommerceDiscount", id: "LIST" }],
    }),

    updateOverallPromotion: builder.mutation<
      ResultsDTO<OverallPromotionResponseDTO>,
      { id: number; data: Partial<OverallPromotionResponseDTO> }
    >({
      query: ({ id, data }) => ({
        url: `admin/ecommerce-discount/update/${id}`,
        method: "PUT",
        body: data,
        headers: {
          origin: "origin",
        },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "EcommerceDiscount", id: "LIST" },
        { type: "EcommerceDiscount", id },
      ],
    }),

    deleteOverallPromotion: builder.mutation<ResultsDTO, number>({
      query: (id) => ({
        url: `admin/ecommerce-discount/delete/${id}`,
        method: "DELETE",
        headers: {
          origin: "origin",
        },
      }),
      invalidatesTags: () => [{ type: "EcommerceDiscount", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAllOverallPromotionsQuery,
  useGetOverallPromotionByIdQuery,
  useGetDiscountsByPriceSlabQuery,
  useCreateOverallPromotionMutation,
  useUpdateOverallPromotionMutation,
  useDeleteOverallPromotionMutation,
} = overallPromotionApiSlice;
